import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from './../environments/environment';
import { ChecklistState } from './store/checklist/checklist.state';
import { AuthState } from './store/auth/auth.state';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';

@NgModule({
  imports: [
    NgxsModule.forRoot([AuthState, ChecklistState], { developmentMode: !environment.production }),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({ name: 'TradeIn' }),
  ],
  exports: [NgxsModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class StateModule {}
